module.exports = __webpack_public_path__ + "assets/navSvg4.8d228974.svg";